import { setShowListPane } from 'owa-mail-layout/lib/actions/setShowListPane';
import { setShowReadingPane } from 'owa-mail-layout/lib/actions/setShowReadingPane';
import { action } from 'satcheljs/lib/legacy';
import { clearListViewVirtualization } from 'owa-mail-list-store';
import { isReadingPanePositionOff } from 'owa-mail-layout/lib/selectors/readingPanePosition';

/**
 * Sets the reading pane and list view show hide as per the new settings selected by user
 * When in dynamic layout the system setting might override user's setting
 */
export default action('onReadingPanePositionOptionSaved')(
    function onReadingPanePositionOptionSaved() {
        setShowListPane(true /* showListPane */);
        setShowReadingPane(!isReadingPanePositionOff() /* showReadingPane */);
        clearListViewVirtualization(false /* isNewTableLoad */);
    }
);
